/**
 * Forge SDK
 * The Forge Platform contains an expanding collection of web service components that can be used with Autodesk cloud-based products or your own technologies. Take advantage of Autodesk’s expertise in design and engineering.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: forge.help@autodesk.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = (function () {
	'use strict';

	var ApiClient = require('../ApiClient');

	/**
	* TokensApi service.
	* @module api/TokensApi
	*/

	/**
	 * Constructs a new TokensApiApi.
	 * @alias module:api/TokensApiApi
	 * @class
	 * @param {module:ApiClient} apiClient Optional API client implementation to use,
	 * default to {@link module:ApiClient#instance} if unspecified.
	 */
	var exports = function (apiClient, region) {
		this.apiClient = apiClient || ApiClient.instance;
		this.region = region || 'US'; // US is default

		/**
		 * Add a new Webhook secret token.
		 * @param {String} token A secret token that is used to generate a hash signature, which is passed along with notification requests to the callback URL
		 * @param {Object} opts Optional parameters
		 * @param {RegionEnum} opts.xAdsRegion Specifies the region the request will be run in. Currently the regions that are supported are: ‘EMEA’, ‘US’. Default is US.
		 * @param {Object} oauth2client oauth2client for the call
		 * @param {Object} credentials credentials for the call
		 */
		this.CreateToken = function (token, opts, oauth2client, credentials) {
			opts = opts || {};

			// verify the required parameter 'token' is set
			if (token == undefined || token == null)
				return Promise.reject("Missing the required parameter 'token' when calling CreateToken");

			var postBody = {
				token: token,
			};

			var pathParams = {};
			var queryParams = {};
			var headerParams = {
				'x-ads-region': opts.xAdsRegion || this.region
			};
			var formParams = {};

			var contentTypes = ['application/json'];
			var accepts = ['application/vnd.api+json', 'application/json'];
			var returnType = Object;

			return this.apiClient.callApi(
				'/webhooks/v1/tokens', 'POST',
				pathParams, queryParams, headerParams, formParams, postBody,
				contentTypes, accepts, returnType, oauth2client, credentials
			);
		};

		/**
		 * Update an existing Webhook secret token
		 * @param {String} token A secret token that is used to generate a hash signature, which is passed along with notification requests to the callback URL
		 * @param {Object} opts Optional parameters
		 * @param {RegionEnum} opts.xAdsRegion Specifies the region the request will be run in. Currently the regions that are supported are: ‘EMEA’, ‘US’. Default is US.
		 * @param {Object} oauth2client oauth2client for the call
		 * @param {Object} credentials credentials for the call
		 */
		this.UpdateToken = function (token, opts, oauth2client, credentials) {
			opts = opts || {};

			// verify the required parameter 'token' is set
			if (token == undefined || token == null)
				return Promise.reject("Missing the required parameter 'token' when calling UpdateToken");

			var postBody = {
				token: token,
			};

			var pathParams = {};
			var queryParams = {};
			var headerParams = {
				'x-ads-region': opts.xAdsRegion || this.region
			};
			var formParams = {};

			var contentTypes = ['application/json'];
			var accepts = ['application/vnd.api+json', 'application/json'];
			var returnType = Object;

			return this.apiClient.callApi(
				'/webhooks/v1/tokens/@me', 'PUT',
				pathParams, queryParams, headerParams, formParams, postBody,
				contentTypes, accepts, returnType, oauth2client, credentials
			);
		};

		/**
		 * Delete a Webhook secret token
		 * @param {Object} opts Optional parameters
		 * @param {RegionEnum} opts.xAdsRegion Specifies the region the request will be run in. Currently the regions that are supported are: ‘EMEA’, ‘US’. Default is US.
		 * @param {Object} oauth2client oauth2client for the call
		 * @param {Object} credentials credentials for the call
		 */
		this.DeleteToken = function (opts, oauth2client, credentials) {
			opts = opts || {};
			var postBody = null;

			var pathParams = {};
			var queryParams = {};
			var headerParams = {
				'x-ads-region': opts.xAdsRegion || this.region
			};
			var formParams = {};

			var contentTypes = ['application/json'];
			var accepts = ['application/vnd.api+json', 'application/json'];
			var returnType = Object;

			return this.apiClient.callApi(
				'/webhooks/v1/tokens/@me', 'DELETE',
				pathParams, queryParams, headerParams, formParams, postBody,
				contentTypes, accepts, returnType, oauth2client, credentials
			);
		};

	};

	/**
	 * Allowed values for the <code>region</code> property.
	 * @enum {String}
	 * @readonly
	 */
	exports.RegionEnum = {
		/**
		 * value: "US"
		 * @const
		 */
		"US": "US",
		/**
		 * value: "EMEA"
		 * @const
		 */
		"EMEA": "EMEA",
		/**
		 * value: "EU"
		 * @const
		 */
		"EU": "EMEA",

	};

	return exports;
}());